import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { InternalNote } from '../models/internal-note';
import { InternalNoteFormValue } from '../components/internal-notes/internal-notes-modal';
import { PaloDraftNoteIds } from '../components/palo/palo-draft-notices';
import { ReceiptNoteType } from '../models/enums/receipt-note-type';

export const GET_INTERNAL_NOTES = 'GET_INTERNAL_NOTES';
export const GET_INTERNAL_NOTES_SUCCESS = 'GET_INTERNAL_NOTES_SUCCESS';
export const GET_RECEIPT_INTERNAL_NOTES = 'GET_RECEIPT_INTERNAL_NOTES';
export const GET_RECEIPT_INTERNAL_NOTES_SUCCESS = 'GET_RECEIPT_INTERNAL_NOTES_SUCCESS';
export const CREATE_INTERNAL_NOTES = 'CREATE_INTERNAL_NOTES';
export const CREATE_INTERNAL_NOTES_SUCCESS = 'CREATE_INTERNAL_NOTES_SUCCESS';
export const UPDATE_INTERNAL_NOTES = 'UPDATE_INTERNAL_NOTES';
export const UPDATE_INTERNAL_NOTES_SUCCESS = 'UPDATE_INTERNAL_NOTES_SUCCESS';
export const DELETE_INTERNAL_NOTES = 'DELETE_INTERNAL_NOTES';
export const DELETE_INTERNAL_NOTES_SUCCESS = 'DELETE_INTERNAL_NOTES_SUCCESS';
export const RESET_RECEIPT_INTERNAL_NOTES = 'RESET_RECEIPT_INTERNAL_NOTES';

export const fetchInternalNotes = (noteType: string, entityId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: GET_INTERNAL_NOTES });

        const response = await api.internalNotes.getInternalNotes(noteType, entityId);

        if (response.success) {
            dispatch({ type: GET_INTERNAL_NOTES_SUCCESS, notes: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchReceiptInternalNotes = (noteType: ReceiptNoteType, entityId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: GET_RECEIPT_INTERNAL_NOTES });

        const response = await api.internalNotes.getReceiptNotes(noteType, entityId);

        if (response.success) {
            dispatch({
                type: GET_RECEIPT_INTERNAL_NOTES_SUCCESS,
                receiptNotes: response.result,
                receiptNoteType: noteType,
            });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

/**
 * The notes of what a document's form holds right now, saved or not. Writes
 * where the saved document's notes go, so the head shows them the same way.
 */
export const fetchDraftNotes = (noteType: ReceiptNoteType, ids: PaloDraftNoteIds, isCurrent: () => boolean) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.internalNotes.getDraftNotes(noteType, ids);

        if (!isCurrent()) {
            return;
        }

        if (response.success) {
            dispatch({
                type: GET_RECEIPT_INTERNAL_NOTES_SUCCESS,
                receiptNotes: response.result,
                receiptNoteType: noteType,
            });
        }
    };
};

export const resetReceiptInternalNotes = () => {
    return async (dispatch: Dispatch) => {
        dispatch({ type: RESET_RECEIPT_INTERNAL_NOTES });
    };
};

export const createInternalNote = (internalNote: InternalNoteFormValue, type: string, id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CREATE_INTERNAL_NOTES });

        const response = await api.internalNotes.create(internalNote, type, id);

        if (response.success) {
            dispatch({ type: CREATE_INTERNAL_NOTES_SUCCESS, note: response.result });
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.internalNotes.create.success')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateInternalNote = (internalNote: InternalNote) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: UPDATE_INTERNAL_NOTES });

        const response = await api.internalNotes.update(internalNote);

        if (response.success) {
            dispatch({ type: UPDATE_INTERNAL_NOTES_SUCCESS, note: internalNote });
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.internalNotes.update.success')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deleteInternalNote = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: DELETE_INTERNAL_NOTES });

        const response = await api.internalNotes.delete(id);

        if (response.success) {
            dispatch({ type: DELETE_INTERNAL_NOTES_SUCCESS, id });
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.internalNotes.delete.success')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
